/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum MediaType {
    Undefined = 0,
    Image = 1,
    PowerPoint = 2,
    Video = 3,
    Audio = 4,
    PDF = 5,
    Excel = 8,
}
